import { Editor, PanelsConfig } from 'grapesjs';
import { addElementToPanel } from '../utils/addElementToPanel';
import { Button, LinkButton, UIText2 } from '@cian/ui-kit';
import { IconActionCopy16 } from '@cian/ui-kit-design-tokens/icons';
import { PasteIcon } from 'shared/components/admin/PasteIcon/PasteIcon';

export const panelsConfig: Partial<PanelsConfig> = {
  defaults: [
    {
      id: 'panel-top',
      el: '.panel__top',
    },
  ],
};

interface IInitializeExtraPanelsParams {
  title: string;
  previewLink: string;
  onSaveClick: (config: Record<string, unknown>) => void;
  onPublishClick: () => void;
}

export const initializeExtraPanels = (
  editor: Editor,
  { title, previewLink, onSaveClick, onPublishClick }: IInitializeExtraPanelsParams,
) => {
  addElementToPanel({
    editor,
    elementId: 'title-text',
    panelName: 'devices-c',
    element: <UIText2 color="white_100">{title}</UIText2>,
  });

  addElementToPanel({
    editor,
    elementId: 'copy-to-clipboard-button',
    panelName: 'devices-c',
    element: (
      <Button
        size="XS"
        theme="fill_white_primary"
        beforeIcon={<IconActionCopy16 color="icon-main-default" />}
        onClick={() => editor.runCommand('CopyComponent')}
        title="Скопировать компоненты"
      />
    ),
  });

  addElementToPanel({
    editor,
    elementId: 'paste-from-clipboard-button',
    panelName: 'devices-c',
    element: (
      <Button
        size="XS"
        theme="fill_white_primary"
        beforeIcon={<PasteIcon />}
        onClick={() => editor.runCommand('cross-tab-paste')}
        title="Вставить компоненты"
      />
    ),
  });

  addElementToPanel({
    editor,
    elementId: 'preview-button',
    panelName: 'options',
    element: (
      <LinkButton size="XS" theme="fill_secondary" href={previewLink} target="_blank">
        Превью
      </LinkButton>
    ),
  });

  addElementToPanel({
    editor,
    elementId: 'save-button',
    panelName: 'options',
    element: (
      <Button size="XS" theme="fill_secondary" onClick={() => onSaveClick(editor.getProjectData())}>
        Сохранить
      </Button>
    ),
  });

  addElementToPanel({
    editor,
    elementId: 'publish-button',
    panelName: 'options',
    element: (
      <Button size="XS" onClick={onPublishClick}>
        Опубликовать
      </Button>
    ),
  });
};
